import { Table, Thead, Tr, Tbody, Td, Tfoot, Th } from "@chakra-ui/table";

import { Box } from "@chakra-ui/react";

const columns = ["Cabeçalho do arquivo", "Tipo", "Obrigatório", "Observação"];

const Header = columns.map((column) => <Th key={column}>{column}</Th>);
const Footer = Header;

export default function ExcelExampleTable({
  rows,
}: {
  rows: ExcelExampleTableRow[];
}) {
  return (
    <>
      <Box
        bg="gray.100"
        py="6px"
        mb="24px"
        fontSize="18px"
        fontWeight="bold"
        textAlign="center"
      >
        Formatação do Excel
      </Box>
      <Table variant="striped" colorScheme="gray">
        <Thead>
          <Tr>{Header}</Tr>
        </Thead>
        <Tbody>
          {rows.map((row) => (
            <Tr>
              <Td>{row.cabecalho}</Td>
              <Td>{row.tipo}</Td>
              <Td>{row.obrigatorio || ""}</Td>
              <Td>{row.observacao}</Td>
            </Tr>
          ))}
        </Tbody>
        <Tfoot>
          <Tr>{Footer}</Tr>
        </Tfoot>
      </Table>
    </>
  );
}

export interface ExcelExampleTableRow {
  cabecalho: string;
  tipo: "texto" | "decimal" | "inteiro";
  obrigatorio?: "Sim" | "Não";
  observacao: any;
}

export const NaoForPreenchido = ({ chidren }: any) => (
  <>
    Se não for preenchido, será usado o do condomínio (somente quando não houver
    inquilino).
    {chidren}
  </>
);

export const MaximoCaracter = (n: number) => (
  <>
    Máximo de <strong>{n}</strong> letras.
  </>
);
